import * as React from "react";
import auth from "../../Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import ColumnMenu from "../../Shared/GridComponents/ColumnMenu";
import { CandidateStatusCell, CellRender, GridNoRecord } from "../../Shared/GridComponents/CommonComponents";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { State } from "@progress/kendo-data-query";
import { DetailColumnCell, ViewMoreComponent, ReqNumberCell, ProviderCell } from "./GlobalActions";
import "../../../assets/css/App.css";
import "../../../assets/css/KendoCustom.css";
import CompleteSearch from "../../Shared/Search/CompleteSearch";
import { downloadExcel, errorToastr, initialDataState } from "../../../HelperMethods";
import { history, successToastr } from "../../../HelperMethods";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import BreadCrumbs from "../../Shared/BreadCrumbs/BreadCrumbs";
import { ExcelDownloadedFileName, GridDataState } from "../../Shared/AppConstants";
import { storeFilters } from "../../Shared/PersistFilteredData";
import { EXCEL_DOWNLOAD_INPROGRESS, NO_DATA_AVAILABLE_TO_GENERATE_REPORT } from "../../Shared/AppMessages";
import reportServices from "../../Shared/Services/ReportServices";


export interface CandidateSubmittalReportProps {
    location?: any;
}

export interface CandidateSubmittalReportState {
    searchString: string;
    data: any;
    allData?: any;
    clientId?: string;
    vendorId?: string;
    dataState: any;
    showRemoveModal?: boolean;
    showCopyModal?: boolean;
    showLoader?: boolean;
    totalCount?: number;
    showHoldPositionModal?: any;
    showReqHistoryModal?: any;
    onFirstLoad: boolean;
}

class CandidateSubmittalReport extends React.Component<CandidateSubmittalReportProps, CandidateSubmittalReportState> {
    private userObj: any = JSON.parse(localStorage.getItem("user"));
    private userClients: any = JSON.parse(localStorage.getItem("UserClientLob"));
    public reqId: string;
    public dataItem: any;
    public openModal: any;
    constructor(props: CandidateSubmittalReportProps) {
        super(props);
        this.state = {
            searchString: "",
            data: [],
            dataState: initialDataState,
            clientId: auth.getClient(),
            vendorId: auth.getVendor(),
            onFirstLoad: true,
            showLoader: true,
        };
    }

    getCandidateSubmittalReport = (dataState) => {
        this.setState({ showLoader: true, onFirstLoad: false, dataState: this.state.dataState });
        reportServices.getCandidateSubmittalReport(dataState, this.state.clientId, this.state.vendorId).then((res) => {
            this.setState({
                data: res.data.items,
                totalCount: res.data.count,
                showLoader: false,
                dataState: dataState
            });
        });
    };

    expandChange = (dataItem) => {
        const { data } = this.state;
        const candSubmittalData = data.map((item) => {
          if (item === dataItem) {
            item.expanded = !item.expanded;
          }
          return item;
        });
        this.setState({
            data: candSubmittalData
        });
    };

    onDataStateChange = (changeEvent) => {
        this.getCandidateSubmittalReport(changeEvent.dataState);
        storeFilters(GridDataState.REPORTCANDIDATESUBMITTAL,changeEvent.dataState);
    };

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    advancedSearchStates = () => {
        let states = {
            division: "",
            originalDivision: [],
            location: "",
        };
        return states;
    };

    render() {
        var params = new URLSearchParams(this.props.location.search);
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-block">
                    <div className="row pt-1 pb-1 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-12 fonFifteen paddingLeftandRight d-flex justify-content-between align-items-center">
                            <BreadCrumbs></BreadCrumbs>
                            <div className="TimeSheet_Excel myorderGlobalicons bg-dark d-flex align-items-center justify-content-center rounded-circle shadow-sm" title="Export to Excel"
                                onClick={() => this.downloadCandidateSubmittalReportExcel()} >
                                <FontAwesomeIcon icon={faFileExcel} className={"text-white ml-2 mr-2"}></FontAwesomeIcon>{" "}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <CompleteSearch
                        placeholder="Search text here!"
                        handleSearch={this.getCandidateSubmittalReport}
                        entityType={"Candidate"}
                        onFirstLoad={this.state.onFirstLoad}
                        page="CandidateSubmittalReport"
                        persistSearchData={true}
                    />
                    <div className="myOrderContainer gridshadow global-action-grid-onlyhead">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.data}
                            {...this.state.dataState}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild report-grid"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>
                            <GridColumn field="reqNumber" 
                           // width="150px" 
                            title="Req#" cell={ReqNumberCell} columnMenu={ColumnMenu} />
                            {auth.hasPermissionV2(AppPermissions.REPORT_MULTI_CLIENT_VIEW) && this.userClients.length > 1 &&<GridColumn
                                field="client"
                                title="Client"
                                cell={(props) => CellRender(props, "Client")}
                                columnMenu={ColumnMenu}
                            />
                            }
                            <GridColumn
                                field="candidateName"
                                title="Candidate Name"
                                cell={(props) => ProviderCell(props)}
                                columnMenu={ColumnMenu}
                            />
                            <GridColumn
                                field="email"
                              //  width="160px"
                                title="Email"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Email")}
                            />
                            <GridColumn
                                field="submittedOn"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                //width="110px" 
                                title="Submitted On"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Submitted On")}
                            />
                            <GridColumn
                                field="vendor"
                                //width="150px" 
                                title="Submitted By"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Submitted By")}
                            />
                            <GridColumn field="status" 
                            //width="250px" 
                            title="Status" columnMenu={ColumnMenu} cell={CandidateStatusCell} />
                            <GridColumn sortable={false} field="expanded" width="80px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                    </div>
                    {params.get('filter') && <div className="row mb-2 mb-lg-4 ml-sm-0 mr-sm-0">
                        <div className="col-12 mt-5 text-sm-center text-center font-regular">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />
                                Close
                            </button>
                        </div>
                    </div>}
                </div>
            </div>
        );
    }
    
    downloadCandidateSubmittalReportExcel = () => {
        var finalState: State = {
          ...this.state.dataState,
          take: null,
          skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        reportServices.getCandidateSubmittalReportForExcel(this.state.clientId, this.state.vendorId, finalState).then((res: any) => {
            if (res) {
                if (res.data === null) {
                    errorToastr(NO_DATA_AVAILABLE_TO_GENERATE_REPORT);
                    return;
                }
                downloadExcel(`${ExcelDownloadedFileName.CANDIDATESUBMITTALREPORT}.xlsx`, res.data);
            }
        });
    }
}
export default CandidateSubmittalReport;
